import React from 'react';

const TableContainer = ({ children }) => {
    return (
        <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-8 overflow-x-auto">
            {children}
        </div>
    );
};

export default TableContainer;
